export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9316.039dfc35.jpg";